import React, { useState } from 'react';
import { Grid, Box, TextField, Autocomplete } from '@mui/material';
import { FormSection, SectionTitle, FieldRow, FieldTitle, StyledPopper } from './StyledComponents';

const AccountsSection = ({
    direction,
    t,
    formData,
    handleInputChange,
    validationErrors,
    accountCardOptions,
    showPdfIframe,
    uploadedDocumentUrl,
    onAddItemSelection
}) => {
    // Track search terms for each field
    const [searchTerms, setSearchTerms] = useState({
        expense: '',
        inputVat: '',
        customsAgent: ''
    });
    return (
        <FormSection>
            <SectionTitle dir={direction}>{t('Accounts')}</SectionTitle>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>
                            {t('Expense')}
                            <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                        </FieldTitle>
                        <Box sx={{ position: 'relative' }}>
                            <Autocomplete
                                options={accountCardOptions || []}
                                getOptionLabel={(option) => option.label}
                                value={
                                    accountCardOptions?.find(
                                        (option) => option.value === formData.expense
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    if (newValue && newValue.value1 === 'AddItem') {
                                        // Handle AddItem selection
                                        onAddItemSelection('expense', searchTerms.expense || '');
                                    } else {
                                        const newExpenseId = newValue ? newValue.value : '';
                                        handleInputChange('expense', newExpenseId);
                                    }
                                }}
                                onInputChange={(event, inputValue) => {
                                    setSearchTerms(prev => ({ ...prev, expense: inputValue }));
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('Expense')}
                                        variant="standard"
                                        InputProps={{
                                            ...params.InputProps,
                                            disableUnderline: true,
                                            sx: {
                                                height: '42px',
                                                width: showPdfIframe && uploadedDocumentUrl ? "170px" : "230px",
                                                padding: '0 10px',
                                                borderRadius: '8px',
                                                background: '#F5F5F6',
                                                border: !formData.expense ? '2px solid #E53E3E' : '1px solid transparent',
                                                '&:focus-within': {
                                                    border: !formData.expense ? '2px solid #E53E3E' : '2px solid #304FFF',
                                                },
                                            },
                                        }}
                                        inputProps={{
                                            ...params.inputProps,
                                            style: {
                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                            },
                                        }}
                                        required
                                        error={!!validationErrors.expense}
                                        helperText={validationErrors.expense}
                                    />
                                )}
                                PopperComponent={(props) => (
                                    <StyledPopper
                                        {...props}
                                        style={{
                                            ...props.style,
                                            direction: direction,
                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.7)',
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </FieldRow>
                </Grid>
                
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>
                            {t('InputVAT')}
                            <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                        </FieldTitle>
                        <Box sx={{ position: 'relative' }}>
                            <Autocomplete
                                options={accountCardOptions || []}
                                getOptionLabel={(option) => option.label}
                                value={
                                    accountCardOptions?.find(
                                        (option) => option.value === formData.inputVat
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    if (newValue && newValue.value1 === 'AddItem') {
                                        // Handle AddItem selection
                                        onAddItemSelection('inputVat', searchTerms.inputVat || '');
                                    } else {
                                        const newInputVatId = newValue ? newValue.value : '';
                                        handleInputChange('inputVat', newInputVatId);
                                    }
                                }}
                                onInputChange={(event, inputValue) => {
                                    setSearchTerms(prev => ({ ...prev, inputVat: inputValue }));
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('InputVAT')}
                                        variant="standard"
                                        InputProps={{
                                            ...params.InputProps,
                                            disableUnderline: true,
                                            sx: {
                                                height: '42px',
                                                width: showPdfIframe && uploadedDocumentUrl ? "170px" : "230px",
                                                padding: '0 10px',
                                                borderRadius: '8px',
                                                background: '#F5F5F6',
                                                border: !formData.inputVat ? '2px solid #E53E3E' : '1px solid transparent',
                                                '&:focus-within': {
                                                    border: !formData.inputVat ? '2px solid #E53E3E' : '2px solid #304FFF',
                                                },
                                            },
                                        }}
                                        inputProps={{
                                            ...params.inputProps,
                                            style: {
                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                            },
                                        }}
                                        required
                                        error={!!validationErrors.inputVat}
                                        helperText={validationErrors.inputVat}
                                    />
                                )}
                                PopperComponent={(props) => (
                                    <StyledPopper
                                        {...props}
                                        style={{
                                            ...props.style,
                                            direction: direction,
                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.7)',
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>
                            {t('CustomsAgent')}
                            <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                        </FieldTitle>
                        <Box sx={{ position: 'relative' }}>
                            <Autocomplete
                                options={accountCardOptions || []}
                                getOptionLabel={(option) => option.label}
                                value={
                                    accountCardOptions?.find(
                                        (option) => option.value === formData.customsAgent
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    if (newValue && newValue.value1 === 'AddItem') {
                                        // Handle AddItem selection
                                        onAddItemSelection('customsAgent', searchTerms.customsAgent || '');
                                    } else {
                                        const newCustomsAgentId = newValue ? newValue.value : '';
                                        handleInputChange('customsAgent', newCustomsAgentId);
                                    }
                                }}
                                onInputChange={(event, inputValue) => {
                                    setSearchTerms(prev => ({ ...prev, customsAgent: inputValue }));
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('CustomsAgent')}
                                        variant="standard"
                                        InputProps={{
                                            ...params.InputProps,
                                            disableUnderline: true,
                                            sx: {
                                                height: '42px',
                                                width: showPdfIframe && uploadedDocumentUrl ? "170px" : "230px",
                                                padding: '0 10px',
                                                borderRadius: '8px',
                                                background: '#F5F5F6',
                                                border: !formData.customsAgent ? '2px solid #E53E3E' : '1px solid transparent',
                                                '&:focus-within': {
                                                    border: !formData.customsAgent ? '2px solid #E53E3E' : '2px solid #304FFF',
                                                },
                                            },
                                        }}
                                        inputProps={{
                                            ...params.inputProps,
                                            style: {
                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                            },
                                        }}
                                        required
                                        error={!!validationErrors.customsAgent}
                                        helperText={validationErrors.customsAgent}
                                    />
                                )}
                                PopperComponent={(props) => (
                                    <StyledPopper
                                        {...props}
                                        style={{
                                            ...props.style,
                                            direction: direction,
                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.7)',
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('CustomsAgentId')}
                            <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                        </FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            width="230px"
                            sx={{ flex: 1 }}
                            value={formData.customsAgentId}
                            onChange={(e) => handleInputChange('customsAgentId', e.target.value)}
                            error={!!validationErrors.customsAgentId}
                            helperText={validationErrors.customsAgentId}
                        />
                    </FieldRow>
                </Grid>
            </Grid>
        </FormSection>
    );
};

export default AccountsSection;